exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#table-active-time-list-table tbody tr td {\n  padding: 0px 0px 0px 8px;\n}\n\n.hms-time {\n  font-family: Arial, Helvetica, sans-serif !important;\n}", ""]);

// exports
